<template>
  <div>
      <v-btn class="primary" type="button" @click="OpenPicker">{{ label }}</v-btn>
  </div>
</template>

<script>
import * as filestack from "filestack-js";
export default {
  props: {
    label: String, 
    apikey: String, // apikey="123456" filestack application apikey goes here
    path: String, // path="/foldername/" this works when using Amazon S3 Bucket
    //security: Object, // security={"policy:'', signature:''}" file stack security options
    policy: String,
    signature: String,
    sources: {
      type: Array,
      default: function() {
        return ["local_file_system"];
      } // v-bind:sources="['local_file_system', 'facebook']"
      /*
        sources include: local_file_system, facebook, url, imagesearch, instagram, googledrive, dropbox,
        webcam, video, audio, box, github, gmail, onedrive, onedriveforbusiness, clouddrive
      */
    },
    accept: Array, // v-bind:accept="['application/pdf', 'image/*']" e.g only accept pdf files, and all images
    maxfiles: {
      type: Number,
      default: 1
    }, // v-bind:maxfiles="2" e.g max number of files to upload
    transformations: {
      type: Object,
      default: function() {
        return {
          crop: true,
          circle: true,
          rotate: true
        };
      } // v-bind:transformations="{crop: true, circle: false, rotate: true}" e.g cropping, circle and rotating
    },
    maxfilesize: {
      type: Number,
      default: 2000000000
    } // v-bind:maxfilesize="5000" e.g max size of files in bytes
  },
  computed: {
    security() {
      if (this.policy !== undefined && this.signature !== undefined) {
        var security = {};
        security.policy = this.policy;
        security.signature = this.signature;       
        return security;
      } else {
        return null;
      }
    }
  },
  methods: {
    OpenPicker() {
      const _this = this;
      const options = {
        displayMode: "inline",
        container: ".picker-content",
        security: this.security,
        uploadConfig: {
          retry: 5,
          timeout: 60000
        }
      };
      const pickerOptions = {};
      pickerOptions.maxFiles = this.maxfiles;
      pickerOptions.transformations = this.transformations;
      if (this.accept !== undefined) {
        pickerOptions.accept = this.accept;
      }
      pickerOptions.fromSources = this.sources;
      pickerOptions.storeTo = { path: this.path };
      pickerOptions.onUploadDone = result => {
        _this.$emit("result", result.filesUploaded);
      };
      pickerOptions.onFileSelected = file => {
        // If you throw any error in this function it will reject the file selection.
        // The error message will be displayed to the user as an alert.
        var maxfilesize = this.maxfilesize * 1000;
        if (file.size > maxfilesize) {
          throw new Error(
            `File too big, select something smaller than ${maxfilesize /
              1000} GB`
          );
        }
      };
      // console.log("security = ", this.security)
      // console.log("options = ", options)
      const client = filestack.init(this.apikey, options);
      client
        .picker(pickerOptions)
        .open()
        .catch(err => {
          _this.$Console.error(err);
        });
    }
  }
};
</script>

<style scoped></style>
